import React from "react";
import { ResponsiveContainer, PieChart, Pie, Label, Cell, Tooltip, Legend } from "recharts";
import { chartColors } from '../../../common/utils';

const TFLabel = ( { viewBox, title, sub } ) => {
    const { cx, cy } = viewBox;
    let ty = cy;
    let sy = cy;
    let tfont = 15;

    switch ( title?.length ) {
        case 1:
            tfont = 40;
            break;
        case 2:
        case 3:
            tfont = 35;
            break;
        case 4:
        case 5:
            tfont = 30;
            break;
        default:

    }
    if ( sub && sub.length ) {
        ty -= 6;
        sy += 18;
    }

    return (
        <>
            <text x={cx} y={ty} fill="#3d405c" className="recharts-text recharts-label" textAnchor="middle" dominantBaseline="central" fontSize={tfont} alignmentBaseline="middle" fontWeight='700'>
                {title}
            </text>
            {
                ( sub && sub.length ) ? (
                    <text x={cx} y={sy} fill="#3d405c" className="recharts-text recharts-label" textAnchor="middle" dominantBaseline="central" fontSize="12" alignmentBaseline="middle">
                        {sub}
                    </text>
                ) : (
                    null
                )
            }
        </>
    )
}

const TFDoughnut = ( { data, w, h, legend, title, sub } ) => {
    let colors = [ ...chartColors ];
    let d = [ ...data ];
    
    const hasData = d.find( f => f.value > 0 );
    if ( !hasData ) {
        d = [ { name: 'Unknown', value: 1 } ];
        colors = [ 'rgba( 0, 0, 0, 0.15' ];
    }

    return (
        <div style={ { width: w ? w : '100%', height: h ? h : '100%' } }>
            <ResponsiveContainer>
                <PieChart>
                    {
                        ( hasData ) ? (
                            <Tooltip />
                        ) : (
                            null
                        )
                    }
                    {
                        ( legend ) ? (
                            <Legend verticalAlign='top' height={30} />
                        ) : (
                            null
                        )
                    }
                    <Pie dataKey="value" data={d} fill="#8884d8" label={false} labelLine={false} outerRadius='95%' innerRadius='75%'>
                        <Label width={30} position="center" content={ <TFLabel title={title} sub={sub} /> } />
                        {
                            data.map( ( entry, idx ) => (
                                <Cell key={ `cell-${idx}` } fill={ colors[idx] } />
                            ) )
                        }
                    </Pie>
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
}

export default TFDoughnut;